/** Read Razorpay redirect params from search or hash query (HashRouter callback). */
export function readRazorpayReturnParams() {
  if (typeof window === "undefined") return null;
  const read = (search) => {
    const p = new URLSearchParams(search || "");
    const paymentId = p.get("razorpay_payment_id");
    const orderId = p.get("razorpay_order_id");
    const signature = p.get("razorpay_signature");
    if (!paymentId || !orderId) return null;
    return { paymentId, orderId, signature: signature || "" };
  };
  return (
    read(window.location.search) ||
    (() => {
      const hash = window.location.hash || "";
      const q = hash.indexOf("?");
      if (q < 0) return null;
      return read(hash.slice(q + 1));
    })()
  );
}

export function loadPendingCheckout() {
  try {
    const raw = sessionStorage.getItem("pb_pending_checkout");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearPendingCheckout() {
  try {
    sessionStorage.removeItem("pb_pending_checkout");
  } catch {
    /* ignore */
  }
}

export function savePendingCheckout(payload) {
  try {
    sessionStorage.setItem("pb_pending_checkout", JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}
